import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {Field, reduxForm} from 'redux-form';
import {getLangCode, stringBundle} from '../../stringBundle';
import {Loader} from '../../components/widgets/Loader';
import * as validation from '../../helpers/validation';

/*eslint-disable no-unused-vars*/
/*eslint-disable no-class-assign*/
/*eslint-disable react/no-multi-comp*/

const renderField = ({input, name, active, type, meta: {touched, error, warning}}) => (
    <div>
        <div className="input-field col s12 no-padding-left">
            <input {...input} className="input-style validate page-input-field" type={type}/>
            {touched && ((error && <span className="message-error">{error}</span>) || (warning && <span className="message-warning">{warning}</span>))}
        </div>
    </div>
);

class EditContactEmail extends Component {

    constructor(props) {
        super(props);
        const {error, initialize, handleSubmit, invalid, pristine, submitting, onSubmit} = props;
        let prefill = {};
        this.renderUpdate = this.renderUpdate.bind(this);
        this.preloadData(this.props.propConAlertEmail);
        this.localizedStringBundle = stringBundle(getLangCode());
    }

    componentDidMount() {
        this.props.initialize(this.prefill);
    }

  componentDidUpdate() {
    this.preloadData(this.props.propConAlertEmail);
    this.props.initialize(this.prefill);
  }

    preloadData(inputData) {
        let prefs = {
            contactEmail: inputData
        }
        this.prefill = Object.assign({}, prefs);
    }

    renderLoader() {
        return (
            <div className="col s12 m12 l11 input-field">
              <div className="contact-email-pref-loader">
                <Loader size="small"/>
              </div>
            </div>
        );
    }

    renderUpdate() {
        return (
            <div className="col s12 m12 l11 input-field">
                <div className="contact-email-pref-btn">
                    <button id="btn-contact-email-update" disabled={this.props.pristine || this.props.submitting || this.props.invalid} className="btn" type="submit">Update</button>
                </div>
            </div>
        );
    }

    render() {
        return (
            <form method="post" onSubmit={this.props.handleSubmit(this.props.onSubmit)} >
            <div className="row">
                <div className="col s12 m4 l4 label padding-left-0">{this.localizedStringBundle.MANAGE_AP_CONTACT_EMAIL}</div>
                <div className="col s12 m7 l7">
                    <Field name="contactEmail" type="text" active="active" component={renderField} validate={[validation.requiredText("Primary Email Address"), validation.maskedOrEmail]} />
                </div>
                {this.props.pristine ? '' : (this.props.submitting ? this.renderLoader() : this.renderUpdate())}
           </div>
           </form>
        )
    }

}

renderField.propTypes = {
    input: PropTypes.object,
    type: PropTypes.string.isRequired,
    meta: PropTypes.object,
    name: PropTypes.string,
    active: PropTypes.string,
};

EditContactEmail.propTypes = {
    error: PropTypes.object,
    initialize: PropTypes.func,
    handleSubmit: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    pristine: PropTypes.bool.isRequired,
    invalid: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    propConAlertEmail: PropTypes.object
};

export default reduxForm({
    form: 'editcontactemail',
})(EditContactEmail);

/*eslint-entable no-unused-vars*/
/*eslint-entable no-class-assign*/
/*eslint-enable react/no-multi-comp*/



// WEBPACK FOOTER //
// ./src/containers/monitoring/EditContactEmailForm.js